import { useEffect, useState } from 'react'
import {
  getLaunchPromoCountdownParts,
  getLaunchPromoRemainingMs,
  isLaunchPromoCountdownVisible,
  type LaunchPromoCountdownParts,
} from '../lib/promo/launchPromo'

export type LaunchPromoCountdownState = {
  /** Licznik promocji wpisowego (z launchPromo.ts, niezależnie od GET /pricing). */
  active: boolean
  remainingMs: number
  parts: LaunchPromoCountdownParts
}

function readCountdownState(): LaunchPromoCountdownState {
  const active = isLaunchPromoCountdownVisible()
  const remainingMs = active ? getLaunchPromoRemainingMs() : 0
  return {
    active,
    remainingMs,
    parts: getLaunchPromoCountdownParts(remainingMs),
  }
}

export function useLaunchPromoCountdown(): LaunchPromoCountdownState {
  const [state, setState] = useState(readCountdownState)

  useEffect(() => {
    const tick = () => setState(readCountdownState())
    tick()
    const id = window.setInterval(tick, 1000)
    return () => window.clearInterval(id)
  }, [])

  return state
}
